import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { useAuthStore } from '../stores';
import { PersonInfoResponse } from '../user.types';

const GET_EMPLOYEE_DATA_QUERY_KEY = 'GET_EMPLOYEE_DATA_QUERY_KEY';
export const useEmployeeDataQuery = (specificEmployeeId?: string, enabled = true) => {
  const { employeeId } = useAuthStore();
  const { data, isLoading, isSuccess } = useQuery(
    [GET_EMPLOYEE_DATA_QUERY_KEY, employeeId, specificEmployeeId],
    // TODO: fix is missing
    () => api.get<PersonInfoResponse>(API_URL.UI_EMPLOYEES_BY_EMPLOYEE_ID(specificEmployeeId || employeeId)),
    {
      enabled: (!!employeeId || !!specificEmployeeId) && enabled,
      cacheTime: 0,
    }
  );
  const employeeAge = useMemo(() => {
    if (!data?.data?.birth_on) return 0;
    const today = dayjs().toDate();
    const birthDate = dayjs(data?.data?.birth_on).toDate();
    let age = today.getFullYear() - birthDate.getFullYear();
    const month = today.getMonth() - birthDate.getMonth();
    if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) age -= 1;
    return age;
  }, [data]);
  return {
    employeeAge,
    rawData: data?.data,
    isLoading,
    isSuccess,
  };
};
